/**
 * Iron Play Intervention Reducers
 */
import {
    RANGEWEDGEPLAY_ACTION,
    FETCH_RANGEWEDGEPLAY,
    ADD_RANGEWEDGEPLAY,
    GET_RANGEWEDGEPLAY,
    EDIT_RANGEWEDGEPLAY,
    DELETE_RANGEWEDGEPLAY,
    RANGECHIPPING_ACTION,
    FETCH_RANGECHIPPING,
    ADD_RANGECHIPPING,
    GET_RANGECHIPPING,
    EDIT_RANGECHIPPING,
    DELETE_RANGECHIPPING,
    RANGEBUNKERPLAY_ACTION,
    FETCH_RANGEBUNKERPLAY,
    ADD_RANGEBUNKERPLAY,
    GET_RANGEBUNKERPLAY,
    EDIT_RANGEBUNKERPLAY,
    DELETE_RANGEBUNKERPLAY,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    rangewedgeplaylist:[],
    particularrangewedgeplay:[],
    rangechippinglist:[],
    particularrangechipping:[],
    rangebunkerplaylist:[],
    particularrangebunkerplay:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case RANGEWEDGEPLAY_ACTION:
            return { ...state, loading: true };
 
        case FETCH_RANGEWEDGEPLAY:
            return { ...state, loading: false, rangewedgeplaylist: action.payload };  
            
        case ADD_RANGEWEDGEPLAY:
            return { ...state, loading: false };    

        case GET_RANGEWEDGEPLAY:
            return { ...state, loading: false, particularrangewedgeplay: action.payload };  
            
        case EDIT_RANGEWEDGEPLAY:
            return { ...state, loading: false }; 
            
        case DELETE_RANGEWEDGEPLAY:
            return { ...state, loading: false };   
            
        case RANGECHIPPING_ACTION:
            return { ...state, loading: true };
    
        case FETCH_RANGECHIPPING:
            return { ...state, loading: false, rangechippinglist: action.payload };  
            
        case ADD_RANGECHIPPING:
            return { ...state, loading: false };    

        case GET_RANGECHIPPING:
            return { ...state, loading: false, particularrangechipping: action.payload };  
            
        case EDIT_RANGECHIPPING:
            return { ...state, loading: false }; 
            
        case DELETE_RANGECHIPPING:
            return { ...state, loading: false };    
        
        case RANGEBUNKERPLAY_ACTION:
            return { ...state, loading: true };
    
        case FETCH_RANGEBUNKERPLAY:
            return { ...state, loading: false, rangebunkerplaylist: action.payload };  
            
        case ADD_RANGEBUNKERPLAY:
            return { ...state, loading: false };    

        case GET_RANGEBUNKERPLAY:
            return { ...state, loading: false, particularrangebunkerplay: action.payload };  
            
        case EDIT_RANGEBUNKERPLAY:
            return { ...state, loading: false }; 
            
        case DELETE_RANGEBUNKERPLAY:
            return { ...state, loading: false };   

         default: return { ...state };
     }
 }